import script from "./WalletRefundsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./WalletRefundsPage.vue?vue&type=script&setup=true&lang=ts"

import "./WalletRefundsPage.vue?vue&type=style&index=0&id=619396c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-619396c8"]])

export default __exports__